import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import PoolTypeInfoBox from './PoolTypeInfoBox'

interface Props {
  hasTimeBlocks: boolean
}

const InfoSection = ({ hasTimeBlocks }: Props) => {
  const { navigation } = useNavigation()
  const url = navigation.timeTracking.fullPath()

  return (
    <Box gap="s48">
      <Box>
        <Text size="100" color="grey800">
          {i18n.t('time_tracking.settings.time_blocks.info_section.table_footer_line')}
        </Text>
      </Box>
      {hasTimeBlocks && (
        <Box flexDirection="row" justifyContent="spaceBetween" gap="s8">
          <Box flexDirection="row" alignItems="center" gap="s24">
            <Box alignItems="baseline" justifyContent="center">
              <PoolTypeInfoBox
                icon="money-bag"
                text={i18n.t(
                  'time_tracking.settings.time_blocks.info_section.compensation_with_payroll'
                )}
              />
              <PoolTypeInfoBox
                icon="clock"
                text={i18n.t(
                  'time_tracking.settings.time_blocks.info_section.compensation_with_time_off'
                )}
              />
              <PoolTypeInfoBox
                icon="balance"
                text={i18n.t(
                  'time_tracking.settings.time_blocks.info_section.compensation_with_balance'
                )}
              />
            </Box>
          </Box>
          <Box flexDirection="row" gap="s16" alignItems="center">
            <Box width="s360">
              <Text size="200">
                {i18n.t('time_tracking.settings.time_blocks.info_section.button_description')}
              </Text>
            </Box>
            <Box width="fit-content">
              <Button.Router type="secondary" to={url}>
                {i18n.t('time_tracking.settings.time_blocks.info_section.button_title')}
              </Button.Router>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default InfoSection
